import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const VisibilityOff = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24.9999 14.5831C27.7622 14.5843 30.411 15.6822 32.3642 17.6355C34.3174 19.5888 35.4151 22.2377 35.4161 25C35.415 26.3074 35.1603 27.6021 34.6661 28.8125L40.7493 34.8956C43.9242 32.2493 46.3819 28.8461 47.8955 25C46.0857 20.396 42.9318 16.4434 38.8445 13.6566C34.7572 10.8698 29.9256 9.37788 24.9786 9.375C22.1508 9.37408 19.3446 9.86755 16.6868 10.8331L21.1868 15.3331C22.3973 14.8389 23.6923 14.5842 24.9999 14.5831ZM4.16613 8.89562L8.91613 13.6456L9.87426 14.6037C6.3922 17.3081 3.70121 20.8988 2.08301 25C3.26911 28.0201 5.04029 30.776 7.29478 33.1095C9.54927 35.4429 12.2426 37.3079 15.2201 38.5972C18.1976 39.8866 21.4005 40.5748 24.6448 40.6225C27.8891 40.6702 31.1108 40.0763 34.1249 38.875L34.9999 39.75L41.1043 45.8331L43.7499 43.1875L6.81238 6.25L4.16613 8.89562ZM15.6874 20.4169L18.9168 23.6462C18.8088 24.0895 18.7528 24.5438 18.7499 25C18.7488 25.8211 18.9097 26.6343 19.2235 27.393C19.5372 28.1518 19.9975 28.8412 20.5781 29.4218C21.1587 30.0024 21.8481 30.4627 22.6068 30.7764C23.3656 31.0901 24.1788 31.2511 24.9999 31.25C25.4563 31.2472 25.9108 31.1912 26.3543 31.0831L29.583 34.3125C27.6388 35.2906 25.4357 35.6308 23.2871 35.2848C21.1384 34.9389 19.1534 33.9243 17.6145 32.3854C16.0756 30.8464 15.061 28.8615 14.715 26.7128C14.3691 24.5641 14.7093 22.3611 15.6874 20.4169ZM24.6668 18.7919L31.2293 25.3544L31.2711 25.0212C31.2722 24.2002 31.1113 23.387 30.7976 22.6282C30.4838 21.8694 30.0235 21.18 29.4429 20.5994C28.8624 20.0189 28.1729 19.5585 27.4142 19.2448C26.6554 18.9311 25.8422 18.7702 25.0211 18.7712L24.6668 18.7919Z"
        fill={color}
      />
    </svg>
  )
}
